export const SORT_OPTIONS = [{
  id: 'firstname',
  label: 'First name'
}, {
  id: 'lastname',
  label: 'Last name'
}, {
  id: 'position',
  label: 'Position'
}, {
  id: 'department',
  label: 'Department'
}];